export default __webpack_public_path__ + "static/media/CeramicsImg.50e4505f.jpg";